<template>
  <div
    v-if="hasAccess(CO_BRANDED_PAGE_ACCESS, CO_BRANDED_PAGE_ACCESS_MANAGE)"
    class="personal-info-list co-branded-page-view co-branded-page-view--customer"
    ref="coBranded"
    style="position:relative"
  >
    <template>
    <b-loading :is-full-page="false" :active="isPreloading"
               :can-cancel="false"></b-loading>
    </template>
    <section class="personal-info-list__item personal-info">
      <AboutHELOC :active="isActiveAboutHELOC" @close="closeAboutHELOC"/>
      <h1>Co-branded Page</h1>
      <validation-observer
                           v-slot="{ handleSubmit, reset }" ref="coBrandedObserver">
        <form @reset.prevent="setSectionNotEditable(COBRANDED_SECTION, reset)"
              @submit.prevent="handleSubmit(submit)"
        >
          <div class="columns" v-if="!isPreloading">
            <div class="column is-10">
              <template v-if="!isEditable(COBRANDED_SECTION) && getCountPages > 1">
                <b-field
                        label="Choose your co-branded page"
                        class="personal-info__field block-title"
                        custom-class="personal-info__field-label">
                </b-field>
                <b-select placeholder="Select a name"
                          class="page-name-selector"
                          v-model="currentPageName"
                          @change.native="changePage"
                >
                  <option
                    v-for="option in pages"
                    :value="option.pageName"
                    :key="option.id">
                    {{ option.pageName }}
                  </option>
                </b-select>
              </template>
              <b-field
                      v-if="createNewPage
                          || ((getCountPages > 1 && (!isEditable(COBRANDED_SECTION) && companyName))
                          || (isEditable(COBRANDED_SECTION) && getCountPages > 1))"
                      label="Company name*"
                      class="personal-info__field block-title"
                      custom-class="personal-info__field-label">
              </b-field>
              <template v-if="createNewPage
                              || (isEditable(COBRANDED_SECTION) && getCountPages > 1)">
                <validation-provider v-slot="{ errors }" name="companyName"
                                     rules="required|max:240">
                  <b-field class="personal-info__field block-title-input"
                           custom-class="personal-info__field-label"
                           :type="{ 'is-danger': errors.length }"
                           :message="errors + [ '&nbsp;' ]">
                    <b-input v-model="companyName"
                             type="text"
                             @blur="()=>{ trimSpaces('companyName') }"
                             maxlength="240"
                    ></b-input>
                  </b-field>
                </validation-provider>
              </template>
              <template v-else-if="getCountPages > 1" >
                <span>{{ companyName }}</span>
              </template>

              <CoBrandedPagePageUrl
                  :page-name.sync="pageName"
                  :editable="isEditable(COBRANDED_SECTION)"
                  :count-of-pages="getCountPages"
                  :category-url-actually="categoryUrlActually"
                  tooltip-text="The URL address of your financing page (branded portal).
                    Allowed symbols for the editable,
                    branded part of the URL: numbers, A-Z, a-z, hyphen."
              />

              <b-field label="Title"
                       class="personal-info__field block-title"
                       :class="(isEditable(COBRANDED_SECTION))?'mt-13':'mt-35'"
                       custom-class="personal-info__field-label">
                <b-tooltip label="The name of your financing page that will be shown in the upper
                part of the marketplace tool (next to your logo). You can leave the title blank,
                but we would recommend using the name of your company here."
                     class="block-tooltip is-gray"
                     type="is-info"
                     size="is-small"
                     :delay="200"
                     position="is-right"
                     animated
                     multilined>
                  <b-icon pack="fa" size="is-small" icon="question-circle">
                  </b-icon>
                </b-tooltip>
              </b-field>
              <template v-if="isEditable(COBRANDED_SECTION)">
                <validation-provider v-slot="{ errors }" name="title"
                                     rules="max:250">
                  <b-field class="personal-info__field block-title-input"
                           custom-class="personal-info__field-label"
                           :type="{ 'is-danger': errors.length }"
                           :message="errors + [ '&nbsp;' ]">
                    <b-input v-model="title"
                             type="text"
                             @blur="()=>{ trimSpaces('title') }"
                             maxlength="250"
                             ></b-input>
                  </b-field>
                </validation-provider>
              </template>
              <template v-else >
                <span>{{ title }}</span>
              </template>

              <CoBrandedPageLogoImage
                  :editable="isEditable(COBRANDED_SECTION)"
                  :alt="companyName"
                  :logo.sync="logo"
                  :blob-image.sync="blobImage"
                  :no-logo-image-url="noLogoImageUrl"
                  :append-to="$refs.coBranded"
                  tooltip-text='The logo that will appear in the top left corner of the marketplace
                   tool on your financing page. Use your company logo as a brand element. To upload
                   your logo, click “CHANGE LOGO” and upload a file, if necessary, crop the uploaded
                   image, and click “DONE”. If you do not have your own logo, a default image will
                   be used on your financing page.'
              />

                <field name="Logo link URL"
                       class="logo-link-url-co-branded-page tooltip-message"
                       v-model.trim="logoLinkUrl"
                       :blur="() => { trimSpaces('logoLinkUrl') }"
                       maxlength="128"
                       :editable="isEditable(COBRANDED_SECTION)"
                       :message="isEditable(COBRANDED_SECTION) ? ['&nbsp;'] : []"
                       rules="url_without_protocol"
                       tooltip="A link directing to your website from your financing page logo.
                       Please make sure your URL starts with “http://” or “https://” and contains
                       your domain name. You can leave it blank"
                       tooltip-classes="is-gray"
                       icon-pack="fa"
                       :position="getTooltipPositionByContentWidth(330, 'is-bottom')"
                >
                  <template v-slot:raw>
                    <a :href="logoLinkUrl"
                       target="_blank">{{ logoLinkUrl }}</a>
                  </template>
                </field>
              <b-field
                label="Funding Designation Agreement"
                class="personal-info__field block-title"
                :class="(isEditable(COBRANDED_SECTION))?'mt-13':'mt-13'"
                custom-class="personal-info__field-label">
                <b-tooltip label="Funding Designation Agreement is a document according to
                which your client agrees to use funds they may be approved for and receive
                as a result of their application only for your services, and no other services,
                provider, or other purpose. FDA is signed at the time
                of filling out the application."
                           class="block-tooltip is-gray"
                           type="is-info"
                           size="is-small"
                           :delay="200"
                           :position="getTooltipPositionByContentWidth(500, 'is-top')"
                           animated
                           multilined>
                  <b-icon pack="fa" size="is-small" icon="question-circle">
                  </b-icon>
                </b-tooltip>
              </b-field>
              <template v-if="isEditable(COBRANDED_SECTION)">
                <template v-if="isFDA">
                  <b-switch
                      class="enh-switch"
                      v-model="fdAgreement"
                      size="is-small"
                      type="is-green">
                  </b-switch>
                </template>
                <template v-else-if="!isFDA">
                  <p>
                    Available only on Pro and Brand Plans. To upgrade your plan contact your
                    personal manager or
                    <a href="mailto:Support@Enhancify.com">Support@Enhancify.com</a>
                  </p>
                </template>
              </template>
              <template v-if="!isEditable(COBRANDED_SECTION)">
                <template v-if="fdAgreement === null">
                  <p>
                    Available only on Pro and Brand Plans. To upgrade your plan contact your
                    personal manager or
                    <a href="mailto:Support@Enhancify.com">Support@Enhancify.com</a>
                  </p>
                </template>
                <template v-else>
                  {{ fdAgreement ? 'On' : 'Off' }}
                </template>
              </template>
              <b-field
                      v-if="ccAcceptance || isEditable(COBRANDED_SECTION)"
                      label="Credit card acceptance*"
                      class="personal-info__field block-title mt-35"
                      custom-class="personal-info__field-label">
                <b-tooltip label="If you accept credit card payments, we can offer
                your customers 0% funding options (provided they have
                sufficient credit score to qualify for the offers)"
                           class="block-tooltip is-gray"
                           type="is-info"
                           size="is-small"
                           :delay="200"
                           :position="getTooltipPositionByContentWidth(500, 'is-top')"
                           animated
                           multilined>
                  <b-icon pack="fa" size="is-small" icon="question-circle">
                  </b-icon>
                </b-tooltip>
              </b-field>
              <template v-if="isEditable(COBRANDED_SECTION)">
                <validation-provider v-slot="{ errors }"
                                     rules="required">
                  <b-field v-model="ccAcceptance"
                           :type="{ 'is-danger': errors.length }"
                           :message="errors + [ '&nbsp;' ]"
                           class="hidden-help">
                    <b-select v-model="ccAcceptance"
                              class="cc-acceptance-selector"
                              :expanded=true>
                      <option value="Yes">Yes</option>
                      <option value="No">No</option>
                      <option value="No, but i'm interested">No, but I'm interested</option>
                    </b-select>
                  </b-field>
                </validation-provider>
              </template>
              <template v-else>
                {{ccAcceptance === 'No, but i\'m interested'
                ? 'No, but I\'m interested' : ccAcceptance}}
              </template>
              <template v-if="isEditable(COBRANDED_SECTION)">
                <template v-if="isHELOC">
                  <b-field
                    label="Home Equity Line of Credit"
                    class="personal-info__field block-title mt-35"
                    custom-class="personal-info__field-label"
                  />
                  <b-switch
                    class="enh-switch"
                    v-model="helocOffer"
                    size="is-small"
                    type="is-green">
                  </b-switch>
                  <p style="margin-top: 10px">
                    HELOC is a home equity line of credit that lets you borrow money against the
                    equity you have in your home.
                    <a class="see-details-button"
                       role="button" @click.prevent="showAboutHELOC">SEE DETAILS</a>
                  </p>
                </template>
              </template>
              <template v-else>
                  <template v-if="helocOffer !== null">
                      <b-field
                              label="Home Equity Line of Credit"
                              class="personal-info__field block-title mt-35"
                              custom-class="personal-info__field-label"
                      />
                      {{ helocOffer !== null ? (helocOffer ? 'On' : 'Off') : '' }}
                      <p style="margin-top: 10px">
                          HELOC is a home equity line of credit that lets
                          you borrow money against the
                          equity you have in your home.
                          <a class="see-details-button"
                             role="button" @click.prevent="showAboutHELOC">SEE DETAILS</a>
                      </p>
                  </template>
              </template>
              <template v-if="blockConciergeView && !isEditable(COBRANDED_SECTION)
              && hasAccess(CO_BRANDED_CONCIERGE_MANAGE, CO_BRANDED_CONCIERGE_MANAGE, true)">
                <b-field
                        label="Concierge service"
                        class="personal-info__field block-title mt-35"
                        custom-class="personal-info__field-label"
                />
                {{ (params.concierge ? 'On' : 'Off') }}
              </template>
            </div>
            <div class="buttons is-pulled-right">
              <template v-if="isEditable(COBRANDED_SECTION)">
                  <button v-if="pageExist" class="button outlined" type="reset">
                    CANCEL
                  </button>
                  <button class="button is-success"
                     type="submit" @submit.prevent="handleSubmit(submit())">{{submitLabel}}</button>
              </template>
              <template v-else>
                  <b-button v-if="hasAccess(CO_BRANDED_PAGE_CREATE_MANAGE,
                                                 CO_BRANDED_PAGE_CREATE_MANAGE, true)"
                            id="add-page-btn"
                            class="button is-pulled-right" type="is-success"
                            @click="addNewPage"
                            icon-pack="fas"
                  >ADD NEW PAGE</b-button>
                  <b-button :disabled="!pageName"
                            id="view-page-btn"
                            class="button is-pulled-right" type="outlined"
                            @click="viewPage"
                            >OPEN LINK</b-button>

                  <b-button class="button is-pulled-right" type="is-success"
                            @click="setSectionEditable(COBRANDED_SECTION)">EDIT</b-button>
              </template>
            </div>
          </div>
        </form>
      </validation-observer>
    </section>
  </div>
</template>


<script>
import { get, isEmpty } from 'lodash';
import {
  mapActions, mapGetters, mapMutations, mapState,
} from 'vuex';
import { SET_CONTRACTOR_HAS_PAGE } from '@/store/mutations';
import {
  addContractorPage, updateContractorPage, pageSettings,
} from '@/api/contractor';
import AboutHELOC from '@/components/Modal/AboutHELOC.vue';
import * as MUTATIONS from '@/store/mutations';
import Field from '@/components/Field.vue';
import * as CONTRACTOR_ACTIONS from '@/store/modules/contractor/actions';
import CoBrandedPageLogoImage from '@/views/CoBrandedPage/components/CoBrandedPageLogoImage.vue';
import CoBrandedPagePageUrl from '@/views/CoBrandedPage/components/CoBrandedPagePageUrl.vue';
import {
  CO_BRANDED_CONCIERGE_MANAGE,
  CO_BRANDED_PAGE_ACCESS,
  CO_BRANDED_PAGE_ACCESS_MANAGE,
  CO_BRANDED_PAGE_CREATE_MANAGE,
} from '@/const/privileges';
import { getTooltipPositionByContentWidth } from '@/utils/getTooltipPosition';
import getPreparedPageName from '@/views/CoBrandedPage/utils/getPreparedPageName';

export default {
  name: 'CoBrandedPageCustomer',
  components: {
    CoBrandedPagePageUrl,
    CoBrandedPageLogoImage,
    AboutHELOC,
    Field,
  },

  data() {
    return {
      COBRANDED_SECTION: 'COBRANDED_SECTION',
      FIELDS: {
        COBRANDED_SECTION: ['pageUrl', 'title', 'logo', 'logoLinkUrl'],
      },
      NO_LOGO_IMAGE_URL: '',
      NO_LOGO_IMAGE: '',
      CO_BRANDED_PAGE_CREATE_MANAGE,
      CO_BRANDED_CONCIERGE_MANAGE,
      CO_BRANDED_PAGE_ACCESS,
      CO_BRANDED_PAGE_ACCESS_MANAGE,
      id: null,
      logo: this.NO_LOGO_IMAGE_URL,
      pageUrl: null,
      companyName: '',
      path: null,
      categoryUrlActually: null,
      contractorPages: [],
      pageName: null,
      title: '',
      logoLinkUrl: null,
      editable: false,
      file: null,
      blobImage: null,
      pageExist: false,
      fullUrl: null,
      fdAgreement: null,
      helocOffer: null,
      concierge: false,
      blockConciergeView: true,
      ccAcceptance: null,
      params: {
        companyName: '',
        pageName: null,
        logoUrl: null,
        title: '',
        logoLinkUrl: null,
        fdAgreement: null,
        helocOffer: null,
        concierge: false,
        ccAcceptance: null,
      },
      isPreloading: false,
      cropModal: null,
      createNewPage: false,
      currentPageName: null,
      isActiveAboutHELOC: false,
      contractorTypeId: 101,
    };
  },
  /**
   * Copy values from vuex state to local state
   */
  created() {
  },
  mounted() {
  },
  deactivated() {
    this.logo = null;
  },
  async activated() {
    if (!this.contractor.id) return;

    this.NO_LOGO_IMAGE = `no-logo_type_${this.contractor.typeId}.png`;
    this.NO_LOGO_IMAGE_URL = `${process.env.VUE_APP_CDN_GET_URL}no-logo_type_${this.contractor.typeId}.png`;
    this.isPreloading = true;
    this.pageName = '';
    this.companyName = '';
    this.pageExist = false;
    this.params.logoUrl = this.NO_LOGO_IMAGE_URL;
    this.params.title = '';
    this.params.companyName = '';
    this.params.logoLinkUrl = null;
    this.blobImage = null;

    await this.getOpportunities();
    await this.updPages(this.contractor.id);
    if (this.pages.length === 1) {
      this.currentPageName = this.pages[0].pageName;
      this.setSectionNotEditable('COBRANDED_SECTION');
      this.setSelectedPage(this.pages[0]);
      this.setPageFieldsFromData(this.pages[0]);
    } else if (this.pages.length === 0) {
      await this.setSectionEditable('COBRANDED_SECTION');
      this.ccAcceptance = this.contractor.ccAccept;
    } else {
      const page = this.pages.find((elem) => (
        elem.pageName === this.contractor.selectedPage.pageName));
      if (page) {
        this.currentPageName = page.pageName;
        this.setSectionNotEditable('COBRANDED_SECTION');
        this.setSelectedPage(page);
        this.setPageFieldsFromData(page);
      }
    }
    if (this.createNewPage) this.companyName = '';
    this.isPreloading = false;
    pageSettings().then((response) => {
      if (response.data) {
        this.categoryUrlActually = response.data.categoryUrl;
      }
    });
  },
  computed: {
    ...mapGetters('user', ['hasPrivilege']),
    ...mapGetters(['hasAccess']),
    ...mapGetters('contractor', ['pages', 'isFDA', 'isHELOC', 'tier', 'plan']),
    ...mapState(['contractor']),
    noLogoImageUrl() {
      return `${process.env.VUE_APP_CDN_GET_URL}no-logo_type_${this.contractorTypeId}.png`;
    },
    editableSections() {
      return this.$store.state.editableSections;
    },
    submitLabel() {
      if (this.pageExist && !this.createNewPage) {
        return 'SUBMIT';
      }
      return 'CREATE';
    },
    getCountPages() {
      if (!isEmpty(this.pages)) {
        return this.pages.length;
      }
      return 0;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },

  watch: {
    editableSections(value) {
      if (!this[value[0]]) {
        Object.keys(this.FIELDS).forEach((field) => {
          this.setSectionNotEditable(field, null);
        });
      }
    },
    pageName(val) {
      if (val) {
        this.pageName = val.replace(/[^-a-zA-Z0-9\s]/gui, '');
        this.pageName = this.pageName.replace(/(\s+)/gui, '-').toLowerCase();
      }
    },
  },
  methods: {
    getTooltipPositionByContentWidth,
    ...mapActions('contractor', {
      setSelectedPage: CONTRACTOR_ACTIONS.SET_SELECTED_PAGE,
      updateContractor: CONTRACTOR_ACTIONS.UPDATE_CONTRACTOR,
      getContractor: CONTRACTOR_ACTIONS.CONTRACTOR,
      updPages: CONTRACTOR_ACTIONS.LOAD_PAGES,
    }),
    ...mapMutations({ setSidebarWidth: MUTATIONS.SET_SIDEBAR_WIDTH }),
    changePage() {
      this.isPreloading = true;
      this.pages.forEach((item) => {
        if (item.pageName === this.currentPageName) {
          this.setSelectedPage(item);
          this.setPageFieldsFromData(item).finally(() => {
            this.isPreloading = false;
          });
        }
      });
    },

    viewPage() {
      const btn = document.getElementById('view-page-btn');
      if (btn) btn.blur();
      window.open(this.fullUrl, '_blank');
    },
    async addNewPage() {
      this.createNewPage = true;
      this.pageName = '';
      this.title = '';
      this.logo = this.NO_LOGO_IMAGE_URL;
      this.logoLinkUrl = null;
      this.companyName = '';
      this.concierge = this.contractor.plan.tier === 'Concierge';
      this.ccAcceptance = this.contractor.ccAccept;
      await this.setSectionEditable('COBRANDED_SECTION');
    },

    trimSpaces(field) {
      this[field] = this[field].replace(/([\s]+)/gu, ' ').replace(/^[\s]|[\s]$/gu, '');
      if (field === 'logoLinkUrl') {
        this[field] = this[field].replace(/([\s]+)/gu, '');
        this[field] = this[field].length > 0 && this[field].slice(0, 4) !== 'http' ? `http://${this[field]}` : this[field];
      }
    },
    /**
     * Check if section is editable
     * @param sectionName
     * @returns {boolean}
     */
    isEditable(sectionName) {
      return this.editableSections.indexOf(sectionName) !== -1;
    },
    /**
     * Add sections name in editableSections list
     * EditForm
     * @param sectionName
     */
    async setSectionEditable(sectionName) {
      await this.getOpportunities();

      this.editableSections.forEach((name) => this.setSectionNotEditable(
        name, null,
      ));
      this.editableSections.push(sectionName);
      if (!this.getCountPages) {
        this.pageName = getPreparedPageName(this.$store.state.contractor.companyName);
        this.title = (this.$store.state.contractor.companyName ?? '');
        this.logoLinkUrl = (this.$store.state.contractor.websiteUrl ?? '');
      }

      if (this.createNewPage) {
        this.fdAgreement = this.isFDA ? true : null;
        this.helocOffer = this.isHELOC ? true : null;
      } else {
        this.fdAgreement = this.isFDA
          ? (this.params.fdAgreement ?? true)
          : null;
        this.helocOffer = this.isHELOC
          ? (this.params.helocOffer ?? true)
          : null;
      }
    },

    /**
     * @todo действительно ли нужна логика с секциями или можно заменить все это на 1 флаг?
     * Remove section name from editableSections list (Cancel)
     * @param sectionName
     * @param reset
     */
    setSectionNotEditable(sectionName, reset = null) {
      this.pageName = this.params.pageName;
      this.companyName = this.params.companyName;
      this.title = this.params.title;
      this.fdAgreement = this.params.fdAgreement;
      this.helocOffer = this.params.helocOffer;
      this.concierge = this.params.concierge === null ? false : this.params.concierge;
      this.ccAcceptance = this.params.ccAcceptance;
      this.logoLinkUrl = this.params.logoLinkUrl;
      this.logo = this.params.logoUrl;
      this.blobImage = null;
      this.createNewPage = false;
      if (this.isEditable(sectionName)) {
        this.editableSections.splice(
          this.editableSections.indexOf(sectionName), 1,
        );
      }
      if (typeof reset === 'function') reset();
      if (this.$refs.coBrandedObserver.flags.invalid) this.$refs.coBrandedObserver.reset();
    },

    /**
     * Submit contractor form
     * @returns {function(): Promise<any>}
     */
    async submit() {
      this.isPreloading = true;
      const formData = new FormData();
      await this.getOpportunities();
      if (this.blobImage && this.logo !== this.NO_LOGO_IMAGE_URL) {
        const file = new File([this.blobImage], 'uploadImage', { type: 'image/png' });
        formData.set('logo', file);
      }
      if (this.logo === this.NO_LOGO_IMAGE_URL || this.logo === this.NO_LOGO_IMAGE) {
        formData.set('logo', this.NO_LOGO_IMAGE);
      }
      formData.set('id', this.contractor.id);
      formData.set('pageName', this.pageName);

      const params = {};
      if (this.title) {
        params.title = this.title.replace(/([\s]+)/gu, ' ').replace(/^[\s]|[\s]$/gu, '');
      }
      params.companyName = this.companyName;
      params.ccAcceptance = this.ccAcceptance;
      params.fdAgreement = this.fdAgreement;
      params.helocOffer = this.helocOffer;
      params.logoLinkUrl = this.logoLinkUrl;

      // checking parameter Concierge into Plan and has privilege CONCIERGE
      if (this.hasAccess(this.CO_BRANDED_CONCIERGE_MANAGE,
        this.CO_BRANDED_CONCIERGE_MANAGE, true)) {
        this.blockConciergeView = true;
        params.concierge = this.concierge;
      }

      formData.set('params', JSON.stringify(params));
      if (this.contractor.id !== null && (this.createNewPage || !this.pageExist)) {
        addContractorPage(formData).then((res) => {
          this.handleResponse(res, true);
          this.createNewPage = false;
          this.isPreloading = false;
        })
          .catch(this.handleFailedContractorPageRequest);
      } else if (this.contractor.id !== null && (!this.createNewPage || this.pageExist)) {
        this.pages.forEach((item) => {
          if (item.pageName === this.params.pageName) {
            formData.set('pId', item.id);
          }
        });
        updateContractorPage(formData).then((res) => {
          this.handleResponse(res);
          this.isPreloading = false;
        })
          .catch(this.handleFailedContractorPageRequest);
      }
    },
    handleFailedContractorPageRequest(error) {
      this.isPreloading = false;
      const isUIErrorMessage = get(error, 'response.data.is_ui_error_message', true);
      if (isUIErrorMessage && error.response.data.error) {
        this.$buefy.toast.open({ message: error.response.data.message, type: 'is-danger' });
      }
    },
    async setPageFieldsFromData(data) {
      this.pageExist = true;
      if (this.createNewPage) return;
      this.params.pageName = data.pageName;
      this.logo = data.logoUrl;
      this.params.companyName = '';
      this.params.fdAgreement = true;
      this.params.helocOffer = true;
      this.params.concierge = false;
      this.params.ccAcceptance = null;
      this.params.logoUrl = data.logoUrl;
      if (data.params) {
        const { params } = data;
        Object.keys(params).forEach((key) => {
          this.params[key] = params[key];
        });
      }
      this.pageName = this.params.pageName;
      this.title = this.params.title;
      this.logoLinkUrl = this.params.logoLinkUrl;
      this.fullUrl = data.fullUrl;

      this.$nextTick(() => {
        this.logo = data.logoUrl;
        this.companyName = this.params.companyName;
        this.fdAgreement = this.params.fdAgreement;
        this.helocOffer = this.params.helocOffer;
        this.concierge = this.params.concierge;
        this.ccAcceptance = this.params.ccAcceptance;
        this.isPreloading = false;
      });
    },

    ...mapMutations({ setHasPage: SET_CONTRACTOR_HAS_PAGE }),
    async handleResponse(response, setHasPage = false) {
      if (response.data.error) {
        this.toast(response.data.message, 'is-danger');
        // this.$buefy.snackbar.open({
        //   type: 'is-danger',
        //   message: response.data.message,
        //   position: 'is-top',
        //   indefinite: true,
        //   actionText: ' ',
        // });
      } else {
        this.currentPageName = this.pageName;
        await this.updPages(this.contractor.id);
        const page = this.pages.find((elem) => (elem.pageName === this.currentPageName));
        if (page) {
          await this.setSelectedPage(page);
          this.setPageFieldsFromData(page);
        }
        this.$buefy.toast.open({ message: `${this.createNewPage ? 'Create' : 'Update'} successful`, type: 'is-success', duration: 3000 });
        if (setHasPage) this.setHasPage(true);
      }
      this.setSectionNotEditable('COBRANDED_SECTION');
    },

    /**
     * Get data Contractor
     * @returns {Promise<void>}
     */
    async getOpportunities() {
      try {
        if (this.contractor.id) {
          await this.getContractor(this.contractor.id);
          if (this.contractor.typeId) {
            this.NO_LOGO_IMAGE = `no-logo_type_${this.contractor.typeId}.png`;
            this.NO_LOGO_IMAGE_URL = `${process.env.VUE_APP_CDN_GET_URL}no-logo_type_${this.contractor.typeId}.png`;
            this.contractorTypeId = this.contractor.typeId;
          }
          this.concierge = this.tier === 'Concierge';
        }
      } catch (error) {
        this.$buefy.toast.open({
          message: error?.response?.data?.message || error?.message,
          type: 'is-danger',
        });
      }
    },
    showAboutHELOC() {
      this.isActiveAboutHELOC = true;
    },
    closeAboutHELOC() {
      this.isActiveAboutHELOC = false;
    },
  },

};
</script>

<style lang="stylus">
.co-branded-page-view.co-branded-page-view--customer
  .image-section-image-wrapper
    width 218px
    height 145px
</style>
